<template>
    <div class="list_item">
        <van-card :title="item.serviceName" @click="handleClick">
            <template #desc>
                <div
                    class="limitHang"
                >{{ item.content ? item.content.slice(3, item.content.length - 4) : "" }}</div>
            </template>
            <template #thumb>
                <van-image width="100" height="100" :src="url" />
            </template>
        </van-card>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            default: () => {
                return {};
            },
            type: Object
        }
    },
    methods: {
        handleClick() {
            this.$emit("click");
        }
    },
    computed: {
        url() {
            if (this.item.serviceThumbnail) {
                return `${process.env.VUE_APP_API_IMGURL}${this.item.serviceThumbnail[0].imgUrl}`;
            } else {
                return "";
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.list_item {
    border-bottom: 1px solid #ddd;
    .van-card {
        height: 110px;
        background-color: #fff;
        .van-card__content {
            padding-top: 6px;
            width: 242px;
            height: 34px;
            opacity: 0.9;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: left;
            color: #7a7a7a;
            margin-left: 20px;
            line-height: 16px;

            .van-card__title {
                margin-bottom: 15px;
                font-size: 14px;
                font-weight: 700;
                color: #000;
            }
        }
    }
    .limitHang {
        line-height: 16px;
        // height: 35px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}
</style>
